import {
   ReactQuery,
   useAlerts,
   displayAndLogErrorWithMessage
} from "@msidata/zeact";
import { useAppContext } from "../data/AppContext";

const queryConfig = {
   suspense: false,
   cacheTime: 0
};

export const useUserSites = (
   userId: number | null,
   groupName?: string | null
): any => {
   const { apiClient } = useAppContext();
   const { issueAlert } = useAlerts();

   const fetchUserSites =
      userId && (groupName || groupName === undefined)
         ? () =>
              apiClient
                 .request({
                    url: `Administration/UserSite`,
                    params: {
                       userId,
                       groupName,
                       $top: 10000,
                       $select: "SiteNumber,SiteName"
                    }
                 })
                 .then(response => response.data.d.results)
                 .catch(error => {
                    displayAndLogErrorWithMessage(
                       error,
                       "UserSitesCannotGet",
                       issueAlert
                    );
                    return Promise.resolve([]);
                 })
         : () => {
              return Promise.resolve(null);
           };

   const { data, isFetching } = ReactQuery.useQuery(
      ["UserSites", { userId, groupName }],
      fetchUserSites,
      queryConfig
   );

   return {
      userSites: data,
      pending: isFetching
   };
};
